/**
 * Utility function to get the current year
 * @returns {number} The current year
 */
export const getCurrentYear = (): number => {
  return new Date().getFullYear();
};
